import { useQuery } from '@tanstack/react-query';
import { useConnection } from 'wagmi';
import { getCapabilities } from 'wagmi/actions';

import { config } from '@/app/providers/app/wagmiConfig';

export const useCheckBatching = (): boolean => {
  const { chainId, connector, status, isConnected, address } = useConnection();

  const { data: capabilitiesStatus } = useQuery({
    queryKey: ['capabilities', chainId, connector?.id, address],
    queryFn: async () => {
      try {
        const capabilities = await getCapabilities(config, {
          chainId: chainId!,
          connector: connector!,
        });

        return (capabilities as { atomic?: { status?: string } })?.atomic?.status || null;
      } catch {
        return null;
      }
    },
    enabled: isConnected && !!chainId && !!connector && status === 'connected',
  });

  return capabilitiesStatus === 'ready' || capabilitiesStatus === 'supported';
};
